import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import universal from 'react-universal-component';
import cx from 'classnames';

import { ConfigContext } from 'Context/config';

import StickyVRM from 'Components/misc/StickyVRM/StickyVRM';
import { TrustpilotReviewsCarousel } from 'Components/reviews/ReviewsCarousel/TrustpilotReviewsCarousel';
import { stepsConfig, stepsTitle } from 'Components/steps/config/howToConfig';
import { StepsSection } from 'Components/steps/StepsSection';
import { Content } from 'LegacySBCRA/Content/Content';

import { RoundedSection } from '../../common/RoundedSection/RoundedSection';
import BrandingContent from '../branding/BrandingContent';
import useBrandName from '../hooks/useBrandName';
import RecentSales from '../recentSales/RecentSales';
import { TrustpilotBespoke } from '../trustpilotBespoke/TrustpilotBespoke';
import { VideoSection } from '../videoSection/VideoSection';

import Hero from './Hero/Hero';
import USP from './Usp/Usp';

import styles from './Home.scss';

const DealerLogos = universal(() => import('../dealerLogos/DealerLogos'), {
  ignoreBabelRename: true,
  loadingTransition: false,
});

const Home = () => {
  const { configState: { brandData } } = useContext(ConfigContext);

  const [stickyVRM, setStickyVRM] = useState(false);
  const [failedReviewsCarousel, setFailedReviewsCarousel] = useState(false);

  const brandName = useBrandName();

  const $content = useRef(null);

  useEffect(() => {
    if ($content.current) {
      setStickyVRM(true);
    }
  }, [$content]);

  const brand = brandData?.brand;

  return (
    <>
      <div className={styles.heroSection}>
        <Hero />
      </div>
      <RoundedSection withBottomLedge>
        <USP />
      </RoundedSection>
      <RoundedSection withBottomLedge withTopLedge theme="off-white">
        <VideoSection />
      </RoundedSection>
      <div ref={$content}>
        {
          stickyVRM && $content?.current && <StickyVRM $content={$content.current} />
        }
        <RecentSales />
        <RoundedSection withBottomLedge withTopLedge className={styles.stepsSectionWrapper} theme="off-white">
          <StepsSection
            config={stepsConfig(brandName)}
            stepsClassName={styles.steps}
            title={stepsTitle}
          />
        </RoundedSection>
        <RoundedSection withBottomLedge withTopLedge>
          {
            brand
              ? (<TrustpilotBespoke {...{ brand }} />)
              : (
                <Content className={styles.trustPilot} element="section" wrapper={{ className: cx(styles.trustPilotWrapper, { [styles.trustPilotWrapperEmpty]: failedReviewsCarousel }) }}>
                  <TrustpilotReviewsCarousel
                    largeTitle
                    failedLoad={failedReviewsCarousel}
                    setFailedLoad={setFailedReviewsCarousel}
                  />
                </Content>
              )
          }
        </RoundedSection>
        <RoundedSection withBottomLedge withTopLedge theme="off-white">
          <DealerLogos />
        </RoundedSection>
        <RoundedSection withBottomLedge withTopLedge>
          <BrandingContent />
        </RoundedSection>
      </div>
    </>
  );
};

export default Home;
